import React from 'react';
import {Helmet} from 'react-helmet';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Button from "react-bootstrap/Button";
import Feedback from '../../components/Feedback/Feedback';
import MainTitle from '../../components/MainTitle/MainTitle';
import classes from './Home.css';

// font awesome icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendarAlt, faShareSquare, faPhoneAlt } from '@fortawesome/free-solid-svg-icons'

import { useMobile } from '../../store/utility';

class Home extends React.Component{

    constructor(props){
        super(props)
        this.caption = React.createRef();
     }

    handleGetStarted = () => {
        window.location.href="/auth";
    }

    handleLearnMore = () => {
        if(this.caption.current){
            this.caption.current.scrollIntoView({ 
               behavior: "smooth", 
               block: "nearest"
            })
        }
    }

    render(){

        let displaySize;
        if (useMobile()===true) {
            // displaySize = 'none';
            displaySize = 'none';
        }
        else {
            displaySize = 'none';
        }

        return (

            <div className={classes.Home}>
                <Helmet>
                    <title>BookMeeY | book a call with friends</title>
                    <meta name="description" content="Book a call with your friend, connects with your friends frequently, making cold calls to friends. A new social solution, BookMeeY." />
                </Helmet>

                <Container className={classes.Home}>

                {/* Title */}
                <div className={classes.Title}>
                    <div className={classes.TitleItem}>
                        <MainTitle></MainTitle>
                        <div className={classes.TitleSubButton}>
                            <Row>
                                <Col lg={6} sm={12}>
                                    <Button size={displaySize} variant="info" onClick={this.handleGetStarted}><b>Get Started</b></Button>
                                </Col>
                                <Col lg={6} sm={12}>
                                    <Button size={displaySize} variant="outline-secondary" onClick={this.handleLearnMore}><b>How It Works</b></Button>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </div>

                {/* Caption */}
                <div className={classes.Caption} id="caption" ref={this.caption}>
                    <Row>
                        <Col>
                            <div className={classes.CaptionItem}>
                                <FontAwesomeIcon icon={faCalendarAlt} style={{color:"var(--color-main)"}} size="3x" />
                                <p className={classes.CaptionItemText}>Create a calendar for your friends to book</p>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <div className={classes.CaptionItem}>
                                <FontAwesomeIcon icon={faShareSquare} style={{color:"var(--color-main)"}} size="3x" />
                                <p className={classes.CaptionItemText}>Share your calendar link on your social media</p>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <div className={classes.CaptionItem}>
                                <FontAwesomeIcon icon={faPhoneAlt} style={{color:"var(--color-main)"}} size="3x" />
                                <p className={classes.CaptionItemText}>Call your friend at the scheduled time</p>
                            </div>
                        </Col>
                    </Row>

                    {/* Action */}
                        <Row>
                            <Col>
                                <div className={classes.Action}>
                                <Button variant="info" onClick={this.handleGetStarted}> <span>Get Started</span> </Button>
                                </div>
                            </Col>
                        </Row>
                </div>

                    {/* Feedback */}
                    <Row>
                        <Col>
                            <div>
                                <Feedback></Feedback>
                            </div>
                        </Col>
                    </Row>
            </Container>

            </div>
        );
    }
}

export default Home;


// WEBPACK FOOTER //
// ./src/containers/Home/Home.js